import { Component, Input, Output, EventEmitter,ViewChild,OnInit,AfterViewInit, OnChanges, SimpleChange, ViewEncapsulation } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FieldConfig } from '../dynamic-form/dynamicForm.interface';
import * as _ from 'lodash';
import { CustomButtonOptions } from './customButton.interface';

@Component({
    selector: 'app-custom-button',
    templateUrl: './custom-button.component.html',
    styleUrls: ['./custom-button.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class CustomButtonComponent implements OnInit, AfterViewInit{
  @Input() options: CustomButtonOptions | undefined;
  @Input() field: FieldConfig | undefined;
  @Input() group!: FormGroup | undefined;

  @Output() onClickEvent: EventEmitter<any> = new EventEmitter<any>();

  parsedOptions: CustomButtonOptions | undefined;

  constructor(){

  }

  ngOnInit(): void{

  }

  ngOnChanges(changes: {options: SimpleChange, field: SimpleChange } ): void {
    if(!this.group){
      if(changes.options)
        this.parseOptions(changes.options.currentValue);
    }

  }

  ngAfterViewInit(): void {
    // autofocus se serve
    /*if(this.field != undefined && this.field.autoFocus != undefined && this.field.autoFocus != false){
      console.warn("Time to autofocus !!!!!!!!!!!!!!!!");
      document.getElementById(this.field!.name)!.focus();
    }*/
  }


  click(event: any) {
    this.onClickEvent.emit(event);
  }



  private parseOptions(options: CustomButtonOptions){
    this.parsedOptions = _.cloneDeep(options);
  }


}
